export default {
    personPreviewData: null,
    errorsBack: [],
    loading: false,
    address1_temp: null,
    uid: null,
    successMsg: false,
    errorPageShow: false,
    
}